import config from "app/config"
import { Platform } from "react-native"

const isWeb = Platform.OS === 'web'

export const makeApiRequest = async <T>(url: string, options: RequestInit): Promise<T> => {
  const cmsUrl = isWeb ? '' : config.cmsBaseUrl; // Use proxy for web
  const response = await fetch(`${cmsUrl}${url}`, options);
  const data = await response.json();
  return data as T;
};